/**
 * État vide piloté UNIQUEMENT par `empty_reasons` du serveur (MON-16-B) :
 * aucun test `=== 0` sur une valeur. Période future → « Période future :
 * aucune activité enregistrée » (D-01), etc.
 */
import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import type { EmptyReason } from '../../../api/monitoring/v2';

export type EmptyStateProps = {
    reasons: EmptyReason[];
    /** Ne retenir que les raisons pertinentes pour la section affichée. */
    only?: readonly EmptyReason[];
};

/** Vrai si le serveur signale au moins une des raisons données. */
export const hasEmptyReason = (reasons: EmptyReason[], among: readonly EmptyReason[]): boolean =>
    reasons.some((reason) => among.includes(reason));

const EmptyState: React.FC<EmptyStateProps> = ({ reasons, only }) => {
    const { t } = useTranslation();
    const shown = only ? reasons.filter((r) => only.includes(r)) : reasons;
    if (!shown.length) return null;
    return (
        <Alert
            type="info"
            showIcon
            role="status"
            data-testid="empty-state"
            message={
                shown.length === 1 ? (
                    t(`monitoring.empty.${shown[0]}`)
                ) : (
                    <ul style={{ margin: 0, paddingInlineStart: 18 }}>
                        {shown.map((reason) => (
                            <li key={reason}>{t(`monitoring.empty.${reason}`)}</li>
                        ))}
                    </ul>
                )
            }
        />
    );
};

export default EmptyState;
